module.exports = __webpack_public_path__ + "img/screen.546f4219.webp";